import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1202588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "market-promotion-ribbon" }
const _hoisted_2 = { class: "market-promotion-ribbon__body" }


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketPromotionRibbon',
  emits: ["close-market-promotion"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_x_link_external = _resolveComponent("x-link-external")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_component_i18n_t, {
        keypath: "modules.ribbons.marketPromotion.message.text",
        tag: "div",
        scope: "global"
      }, {
        linkText: _withCtx(() => [
          _createVNode(_component_x_link_external, {
            href: _ctx.$t('modules.ribbons.marketPromotion.message.linkHref')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('modules.ribbons.marketPromotion.message.linkText')), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("button", {
      class: "market-promotion-ribbon__close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close-market-promotion')))
    }, [
      _createVNode(_component_ot_icon, { name: "close" })
    ])
  ]))
}
}

})